const colordepths = [
  { key: 'Low color (8 bit)', value: 8 },
  { key: 'High color (16 bit)', value: 16 },
  { key: 'True color (24 bit)', value: 24 },
  { key: 'Not set / Follow server', value: '' },
];

export default colordepths;
